import React, { Component } from 'react';

class ContactPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    document.title = 'The Daily: Contact';
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {

  }

  render() {
    return (
      <div>
        <p>
          {'Testing contact content'}
        </p>
      </div>
    );
  }
}

export default ContactPage;



// WEBPACK FOOTER //
// ./src/components/ContactPage.jsx